export const qaLabelJobRequestForm = {
    createBtn: 'job-request-form--create-btn',
};